import { Button, useAboveBreakpoint } from "imaginarity-react-ui";
import * as React from "react";
import { gotoNamedRouteMethod } from "services/Helpers/RoutingHelper";
import History from 'services/History';
import { useImgI18N } from "services/ImgI18N";
import { PlaylistDetailSC as T } from 'views/Playlist/PlaylistDetailSC';


interface PlaylistDetailErrorProps {
    banner: string | undefined;
    stickyHeader: boolean;
    id: string;
    bannerTop: { playlist: string };
}

const PlaylistDetailError = (p: PlaylistDetailErrorProps) => {
    const { banner, stickyHeader, id, bannerTop } = p;
    const { t } = useImgI18N("playlist");
    const isTablet = useAboveBreakpoint("largeMobile");

    return (
        <T.ErrorContainer>
            <T.BannerContainer imageUrl={banner ?? bannerTop.playlist} stickyHeader={stickyHeader} >
                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(90deg, rgba(224, 0, 0, 0.9) 0%, rgba(255, 255, 255, 0.7) 70%)" }} />
                <T.BannerTitle >
                    <span style={{ marginLeft: 10 }}>{t('error loading playlist')}</span>
                    {isTablet &&
                        <div style={{
                            position: "absolute", right: "calc(5.56% - 6px)", top: 10,
                            // position: "absolute", right: "100px", top: 10,
                            width: "auto",
                            height: 40, background: "rgba(255, 255, 255, 0.0)", boxShadow: "0 6px 8px -6px #000"
                        }}>

                            <Button
                                kind='primary'
                                tooltip={{ tooltipText: t("playlist overview"), position: "bottom" }}
                                floated='right'
                                icon="home"
                                onClick={gotoNamedRouteMethod("playlist")}
                            />
                            <Button
                                kind='cancelButton'
                                tooltip={{ tooltipText: t("back"), position: "bottom" }}
                                floated='right'
                                icon="chevron left"
                                onClick={() => History.goBack()}
                            />
                        </div>
                    }
                </T.BannerTitle>
            </T.BannerContainer>
            <div className='info'>
                {t("an error occurred while loading the playlist ({{plid}})", { plid: id })}.
            </div>
            <div onClick={gotoNamedRouteMethod("playlist")} className='link'>
                {t("please try again later or go back to the overview")}.
            </div>

        </T.ErrorContainer>
    );
}

export default PlaylistDetailError;